import { useSyncExternalStore } from 'react';

function subscribe(callback: () => void) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

function getSnapshot() {
  return navigator.onLine;
}

function getServerSnapshot() {
  return true;
}

/**
 * Returns true when the device has network connectivity.
 * Reactively updates on online/offline browser events.
 */
export function useNetwork(): { online: boolean } {
  const online = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return { online };
}
